import { render } from "./TribesInformationList.vue?vue&type=template&id=71b924f4&ts=true"
import script from "./TribesInformationList.vue?vue&type=script&lang=ts"
export * from "./TribesInformationList.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__